import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';
import { RolService } from 'src/app/services/rol.service';
import { CaseFile } from '../../../interface/CaseFile.interface';
import { UserService } from 'src/app/core/services/user.service';
import { ModalFileShowViewComponent } from 'src/app/components/shared/components/modal-file-show-view/modal-file-show-view.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'file-item',
  templateUrl: './file-item.component.html',
  styleUrls: ['./file-item.component.scss'],
})
export class FileItemComponent implements OnInit {
  @Input() file: CaseFile;
  @Input() case;
  @Output() deleteFile = new EventEmitter<string>();
  permisosStr: string = null;
  constructor(
    public rolesService: RolService,
    private readonly userService: UserService,
    private readonly dialog: MatDialog
  ) {}

  get canEdit() {
    return this.userService.permissions.editCases;
  }
  get status() {
    return this.case.status == 'archived';
  }
  ngOnInit() {
    this.permisosStr = this.rolesService.permisos.toString();
  }

  get date() {
    return moment(this.file.createdAt).format('d/MM/yyyy h:mm a	 HH:mm');
  }

  view() {
        this.dialog
          .open(ModalFileShowViewComponent, {
            data: this.file,
            minWidth: '1%',
          })
          .afterClosed()
          .subscribe(async (re) => {});
  }

  download() {
    const path = this.file.url + `?name=${this.file.name}&download=true`;
    var a = document.createElement('a');
    a.href = path;
    a.download = path.substr(path.lastIndexOf('/') + 1);
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  delete() {
    this.deleteFile.emit(this.file._id);
  }
}
